
module dgUtils {
    
    export interface IDgDurationFilter extends Function {
        (startDate: Date, endDate: Date): string;
    }

    interface DgLocaleDuration {
        year: string;
        month: string;
        day: string;
    }

    function duration($locale: ng.ILocaleService, $localeDurations: DgLocaleDuration): IDgDurationFilter {
        return (fromDateIn: Date, toDateIn: Date) => {
            function fullYear(year: number): string {
                return year % 4 == 0 ? 'leapMonths' : 'months';
            }
            var words = [];

            var fromDate = fromDateIn <= toDateIn ? fromDateIn : toDateIn;
            var toDate = fromDateIn <= toDateIn ? toDateIn : fromDateIn;
            if (fromDateIn <= toDateIn) {
                fromDate = fromDateIn
                toDate = toDateIn;
            } else {
                fromDate = toDateIn
                toDate = fromDateIn;
                words.push('-');
            }
            
            var yearsRaw = toDate.getFullYear() - fromDate.getFullYear();
            var monthsRaw = toDate.getMonth() - fromDate.getMonth() + (yearsRaw * 12);

            var years = Math.floor(monthsRaw / 12);
            var months = monthsRaw % 12;
            var days;
            if (toDate.getDate() >= fromDate.getDate()) {
                days = toDate.getDate() - fromDate.getDate();
            } else {
                months--;
                var fromDateRemaining = $localeDurations[fullYear(fromDate.getFullYear())][fromDate.getMonth()] - fromDate.getDate();
                days = fromDateRemaining + toDate.getDate();
            }
            var durationObj = {
                year: years,
                month: months,
                day: days
            };

            angular.forEach(durationObj, (value: number, key: string) => {
                if (value != 0) {
                    words.push($localeDurations[$locale.pluralCat(value)][key].replace('{}', String(value)));
                }
            });
            return words.join(' ');

        }
    }
    duration.$inject = ['$locale', '$localeDurations'];


    angular.module('dgUtils')
        .factory('$localeDurations', [function () {
            return {
                'one': {
                    year: '{} year',
                    month: '{} month',
                    day: '{} day'
                },
                'other': {
                    year: '{} years',
                    month: '{} months',
                    day: '{} days'
                },
                'months': [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
                'leapMonths': [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
            };
        }])
        .filter('duration', duration);
    
}